import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.futurions.portfolio.pages.HomePage as _com_futurions_portfolio_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Portfolio"))
    BasePath.set("/KobwebPortfolio/")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_futurions_portfolio_pages_HomePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("code-sphere3-d", com.futurions.portfolio.animations.CodeSphere3DStyle)
        ctx.theme.registerStyle("page-content", com.futurions.portfolio.pages.PageContentStyle)
        ctx.theme.registerKeyframes("rotate-sphere3-d", com.futurions.portfolio.animations.RotateSphere3D)
        ctx.theme.registerKeyframes("orbit-rotate", com.futurions.portfolio.animations.OrbitRotate)
        ctx.theme.registerKeyframes("orbit-reverse", com.futurions.portfolio.animations.OrbitReverse)
        ctx.theme.registerKeyframes("glow-pulse", com.futurions.portfolio.animations.GlowPulse)
        ctx.theme.registerKeyframes("neon3-d-tilt", com.futurions.portfolio.animations.Neon3DTilt)
        com.futurions.portfolio.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.futurions.portfolio.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
